import StripePayment from './stripe-payment'
import { useEffect } from 'react'
import { callAPI } from '@/hooks/api'
import { useNavigate } from 'react-router'
import StripePaymentLayout from './_component/stripe-payment-layout'

interface IProps {
  setCurrentTab: (value: string) => void
  setJoyrideRun: (value: boolean) => void
  setFirstLogin: (value: boolean) => void
}

export default function Subscribe(props: IProps) {
  const { setCurrentTab, setJoyrideRun, setFirstLogin } = props
  setCurrentTab('subscribe')
  const localAuth = JSON.parse(localStorage.getItem('auth') as string)
  const removeStylesheet = (href: string) => {
    const link = document.querySelector(`link[href="${href}"]`)
    if (link && link.parentElement) {
      link.parentElement.removeChild(link)
    }
  }
  removeStylesheet('/css/landing.css')
  removeStylesheet('/css/bootstrap.css')

  const navigate = useNavigate()

  useEffect(() => {
    if (!Object.keys(localAuth).length) {
      navigate('/sign-in')
    } else {
      callAPI('/get_is_subscribed', { session_key: localAuth.sessionKey }).then(
        (res) => {
          if (res.is_subscribed) {
            navigate('/')
          }
        }
      )
    }
  }, [localAuth])

  return (
    <StripePaymentLayout>
      <StripePayment
        setJoyrideRun={setJoyrideRun}
        setFirstLogin={setFirstLogin}
      />
    </StripePaymentLayout>
  )
}
